export const MIN_WEAK_PASSWORD_GROUPS = 1;
export const MEDIUM_WEAK_PASSWORD_GROUPS = 3;
export const STRONG_WEAK_PASSWORD_GROUPS = 5;
